import Image from '../Image';

import { AccordionArrowIconProps } from './types';

const AccordionArrowIcon = ({ className, width = 30, height = 30 }: AccordionArrowIconProps) => (
  <Image
    src={'/marketplace-static/images/icons/accordionArrow.svg'}
    alt="triangle icon"
    width={width}
    height={height}
    className={className}
  />
);

export default AccordionArrowIcon;
